import { helpers } from './theme/helpers.js';
import { headerMenu } from './theme/components/header-menu.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	init: function () {
		var self = this;

		self.runLightbox();
	},

	runLightbox: function() {
		setTimeout(function(){
			var lightbox = new SimpleLightbox( '.block-gallery ul a' );
		}, 250 );
	},
};

jQuery(document).ready(function ($) {
	theme.init();
	headerMenu.init();
});